import { Dispatch, ReactNode, SetStateAction } from 'react';

import { SchemaEditorModalBody } from '@/components/SchemaEditor/SchemaEditorModalBody';
import { PromptTool } from '@/utils/ai-tools';

import { StructuredPromptSchema } from '../../components/manifest/serialized/prompts/ManifestStructuredPrompt';
import { convertStructuredPromptSchemaToTool } from './convertTools.utils';

interface CustomToolEditorProps {
  title: ReactNode;
  value: StructuredPromptSchema;
  setValue: Dispatch<SetStateAction<StructuredPromptSchema>>;
  onSubmit: (tool: PromptTool) => void;
  onRemove?: () => void;
  onClose: () => void;
  saveDisabled?: boolean;
  saveTooltipText?: string;
  error?: string;
}

export const CustomToolEditor = ({
  title,
  value,
  setValue,
  onSubmit,
  onRemove,
  onClose,
  saveDisabled,
  saveTooltipText,
  error,
}: CustomToolEditorProps) => {
  const handleSubmit = (value: StructuredPromptSchema | PromptTool) => {
    if (
      typeof value === 'object' &&
      'type' in value &&
      value.type === 'object'
    ) {
      const mFunction = convertStructuredPromptSchemaToTool(
        value as StructuredPromptSchema
      );
      onSubmit({
        type: 'function',
        function: mFunction,
      });
      return;
    }
    onSubmit(value);
  };

  return (
    <SchemaEditorModalBody
      title={title}
      value={value}
      setValue={setValue}
      onSubmit={handleSubmit}
      onRemove={onRemove}
      onClose={onClose}
      saveDisabled={saveDisabled}
      saveTooltipText={saveTooltipText}
      error={error}
      readOnly={false}
    />
  );
};
